// Test IDs for the language switcher (EN / RU / ID). Keys camelCase, values
// kebab-case — see auth.js.
//
// The values stay English whatever the interface language is: a translated
// testid is an element the e2e agent cannot find.

export const LANGUAGE = {
	switcher: 'language-switcher',
	// The globe at the foot of every screen — its own id, so a screen that also
	// carries the settings pill (Profile) never holds two identical switchers.
	footer: 'language-footer',
	option: (code) => `language-option-${code}`,
	sheet: 'language-sheet',
};
